import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { PatientProfileProvider, usePatientProfile } from 'apps/wrapper/src/hooks/use-patient-profile';
import { ReviewSummaryDialog } from 'apps/wrapper/src/components/shared/patient-feedback/dialogs/review-summary/review-summary';
import { EventOpenReviewSummary } from 'apps/wrapper/src/types/event-bus';
import { FC, useEffect, useState } from 'react';

interface ReviewSummaryLoaderProps {
  reviewId: number;
  patientId: number | null;
  onClose: () => void;
}

const ReviewSummaryLoader: FC<ReviewSummaryLoaderProps> = ({ reviewId, patientId, onClose }) => {
  const { contactDetails, loadPatientDataById } = usePatientProfile();

  useEffect(() => {
    if (patientId) {
      loadPatientDataById(patientId);
    }
  }, [patientId]);

  // Wait for patient data only when we have a patientId
  if (patientId && !contactDetails) return null;

  return (
    <ReviewSummaryDialog
      reviewId={reviewId}
      open={true}
      onClose={onClose}
    />
  );
};

export const ReviewSummaryEventListener = () => {
  const { listen } = useEventBus();
  const [state, setState] = useState<EventOpenReviewSummary['data'] | null>(null);

  useEffect(
    () =>
      listen('openReviewSummary', (event: any) => {
        const data = (event as EventOpenReviewSummary).data;
        setState(data);
      }),
    [listen]
  );

  if (!state) return null;

  return (
    <PatientProfileProvider>
      <ReviewSummaryLoader
        reviewId={state.reviewId}
        patientId={state.patientId}
        onClose={() => setState(null)}
      />
    </PatientProfileProvider>
  );
};
